// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Dzqp","buttons":"PendingPaymentAlert_buttons__Is5v5"};